<app-filter-multi-select
	[appearance]="appearance"
	[labelKey]="labelKey"
	[placeholderKey]="placeholderKey"
	[selectedCountKey]="selectedCountKey"
	[selectedListAriaLabelKey]="selectedListAriaLabelKey"
	[removeSelectionAriaLabelKey]="removeSelectionAriaLabelKey"
	[options]="options"
	[optionLabels]="optionLabels"
	[showSearchInput]="true"
	[useServerFilteredOptions]="true"
	[isDisabled]="isSelectDisabled"
	[(ngModel)]="value"
	(ngModelChange)="onSelectionChange($event)"
	(searchTermChange)="onSearchTermChange($event)"
></app-filter-multi-select>
